import { render, staticRenderFns } from "./attendance-by-student.vue?vue&type=template&id=54730a78"
import script from "./attendance-by-student.vue?vue&type=script&lang=js"
export * from "./attendance-by-student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports